"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PILL_TYPES = exports.PILL_SIZES = void 0;
var PILL_TYPES = exports.PILL_TYPES = {
  GHOST: 'pill--ghost',
  SUCCESS: 'pill--success',
  BLACK: 'pill--black',
  ERROR: 'pill--error',
  SOLD_OUT: 'pill--sold-out',
  COMING_SOON: 'pill--coming-soon',
  LIMITED: 'pill--limited',
  SUCCESS_INVERT: 'pill--success-invert',
  PRIMARY: 'pill--primary',
  SECONDARY: 'pill--secondary',
  ORANGE: 'pill--orange',
  FESTIVAL: 'pill--festival',
  BVI: 'pill--bvi',
  WARNING: 'pill--warning'
};
var PILL_SIZES = exports.PILL_SIZES = {
  SMALL: 'pill--sm',
  MEDIUM: 'pill--md'
};